<div edsGrid [ngClass]="{ 'has-edit-button': isEditMode }">
  <ng-container
    *ngIf="isEditMode"
    [brManageContentButton]="document"
    documentTemplateQuery="new-widget-document"
    folderTemplateQuery="new-widget-folder"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>
  <ng-container *ngIf="interactiveWidgets">
    <ng-container
      *ngIf="
        (interactiveWidgetsParams.experiment &&
          (patToolVariation$ | async) === interactiveWidgetsParams.variation) ||
        !interactiveWidgetsParams.experiment
      "
    >
      <div
        *ngFor="let widget of interactiveWidgets"
        [class.interactive-widgets--add-padding]="
          interactiveWidgetsParams.addPadding
        "
      >
        <ng-container
          [ngTemplateOutlet]="widgetTemplate"
          [ngTemplateOutletContext]="{ widget: widget }"
        >
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>
<!-- show the cta basic widget-->
<ng-template #widgetTemplate let-widget="widget">
  <eds-cta-basic
    *ngIf="
      widget.isFirmAllowed && !isBypassUser && (widget.isDisplayed$ | async)
    "
    [theme]="widget.theme"
    [hasImg]="!!widget?.imgSrc"
    [imgSrc]="widget?.imgSrc"
    [class]="'interactive-widgets__cta-interactive-widget'"
  >
    <ng-container>
      <div
        class="interactive-widgets-interactive-content"
        [innerHTML]="widget?.description?.value | safeHtml"
      ></div>
      <ft-pcs-tool
        *ngIf="widget?.interactiveConfigImpl && widget?.labelsImpl"
        [pcsConfig]="widget.interactiveConfigImpl"
        [pcsLabels]="widget.labelsImpl"
        [class]="'interactive-widgets__pcs-tool-interactive-widget'"
      ></ft-pcs-tool>
    </ng-container>
  </eds-cta-basic>
</ng-template>
